<script setup lang="ts">
import { classMerge } from '../utils'

import type { WithClassAsProps } from './carousel-interface'

const props = defineProps<WithClassAsProps>()
</script>

<template>
  <span :class="classMerge(
    'hidden',
    props.class
  )">
    <slot />
  </span>
</template>
